import debug from "debug";

const log = debug("type-tester:ascender-padding");

export function applyAscendersDescenderCorrection(
  editorElement,
  ascenderCorrection,
  descenderCorrection
) {
  // #applysampleformatting ascender-correction

  const renderedTextElement = editorElement.parentElement;

  renderedTextElement.style.setProperty(
    "--ascender-padding",
    `${ascenderCorrection}px`
  );
  renderedTextElement.style.setProperty(
    "--descender-padding",
    `${descenderCorrection}px`
  );
}

// Called from font-scaler.js
/**
 * Calculates the correction needed for the ascender or descender
 * @param {*} lineHeightNorm The minimum line hight at which correction is not needed
 * @param {*} lineHeight The current line height
 * @param {*} fontSize
 * @returns
 */
export function correctionPixels(lineHeightNorm, lineHeight, fontSize) {
  const correctionUnscaled = Math.max(0, (lineHeightNorm - lineHeight) / 2);
  const correctionScaled = (correctionUnscaled * fontSize) / 100;
  // log(
  //   `- lineHeightNorm: ${lineHeightNorm}\n` +
  //     `  lineHeight: ${lineHeight}\n` +
  //     `  fontSize: ${fontSize}\n` +
  //     `  correctionUnscaled: ${correctionUnscaled}\n` +
  //     `  correctionScaled: ${correctionScaled}`
  // );
  return correctionScaled;
}
